import { stepsFullPath } from "../stepsPath";

export const step9_1Path = "/9_1";
export const step9_1FullPath = `${stepsFullPath}${step9_1Path}`;
export const step9_1Caption = "Photo & Video intro";
